import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { Onboarding } from './onboarding';
import { User } from './user';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  private _storage: Storage | null = null;

  constructor(
    private storage: Storage,
    public router: Router,
    public platform: Platform
    ) {
      this.init();
    }

  async init() {
    if(!this.platform.is('cordova')) {
      this.router.navigate(["/tabs/home"], { replaceUrl: true });
    }
    else {
      const storage = await this.storage.create();
      this._storage = storage;
    }
  }

  public async saveOnboarding(obj: Onboarding)
  {
    return await this._storage?.set("onboarding", obj);
  }

  public async getOnboardingData()
  {
    return await this._storage?.get("onboarding");
  }

  public async deleteOnboarding()
  {
    return await this._storage?.remove("onboarding");
  }

  public async checkUser(user: User)
  {
    //Check if existing user has already finished Onboarding
    //Skip onboarding for Student, Teacher and SchoolAdmin roles
    if(user && !user.onboarding && user.role != "Teacher" && user.role != "SchoolAdmin" && user.role != "Student")
    {
      this.router.navigate(["anamnese"], { replaceUrl: true });
    }
  }
}
